export enum PROFESSIONAL_LEARNING_MUX_VIDEO_ID {
  CLASS_CONTENT_POLICIES_ACTIVITY_ID = "ysYPACRLVhZ6qoD1LSWXx1CLBOKBZysr",
  SAFETY_AND_PRIVACY_ACTIVITY_ID = "B02018Lg5PNDV3RiqzAg6q1L7SGN00Q4B2d",
}
